import React, { FunctionComponent } from "react";
import { ScrollTable } from "../../../components";
import { CONSTANTS as C, useTranslate } from "../../../helpers";
import { AbstractBenefitsTableData } from "./AbstractBenefitsHelpers";

const AbstractBenefitsTable: FunctionComponent<{
  tableData: AbstractBenefitsTableData;
}> = ({ tableData: { headers, rows, footnotes } }) => {
  const t = useTranslate();

  return (
    <div className="AbstractBenefitsTable" id="abstract-benefits-table">
      <ScrollTable>
        <thead>
          <tr>
            {headers.map((header, idx) => (
              <th key={`${header.heading}-${idx}`}>
                {header.heading}
                {header.footnoteIdx && <sup>{header.footnoteIdx}</sup>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={`row-${i}`}>
              {row.map((col, j) => {
                if (col.isGeneric && col.generalCost && i === 0) {
                  return (
                    <td rowSpan={rows.length} key={`cell-${i}-${j}`}>
                      <div className="ds-u-display--flex m-u-flex-direction--column ds-u-justify-content--center">
                        <span>
                          {t(
                            C.abstractBenefitTierTranslations
                              .COST_SHARE_TIER_GENERIC_DRUGS
                          )}
                          :
                        </span>
                        <span
                          className="ds-u-margin-bottom--2"
                          dangerouslySetInnerHTML={{
                            __html: col.generalCost.generic,
                          }}
                        />
                        <span>
                          {t(
                            C.abstractBenefitTierTranslations
                              .COST_SHARE_TIER_BRAND_NAME_DRUGS
                          )}
                          :
                        </span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: col.generalCost.brand,
                          }}
                        />
                      </div>
                    </td>
                  );
                } else if (!col.isGeneric) {
                  return (
                    <td key={`cell-${i}-${j}`}>
                      {col.title}
                      {col.cost}
                    </td>
                  );
                }

                return null;
              })}
            </tr>
          ))}
        </tbody>
        <tfoot>
          {footnotes.length > 0 &&
            footnotes.map((footnote, i) => (
              <tr className="ds-u-border-top-top--1" key={`${footnote}-${i}`}>
                <td colSpan={footnote.colspan}>
                  <sup>{i + 1}</sup>
                  {t(footnote.footnote)}
                </td>
              </tr>
            ))}
        </tfoot>
      </ScrollTable>
    </div>
  );
};

export default AbstractBenefitsTable;
